<template>
    <div>
        <div class="page-wrapper">
            <!-- <div class="page-header d-print-none">
                <div class="container-xl">
                    <div class="row g-2 align-items-center">
                        <div class="col">
                            <div class="page-pretitle">
                                Usted se encuentra aquí:
                            </div>
                            <h2 class="page-title">
                                Staff
                            </h2>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="page-body">
                <div class="container-xl">
                    <div class="row g-2 align-items-center">
                        <div class="col">
                            <h2 class="text-center">
                                Staff
                            </h2>
                        </div>
                    </div>
                    <br>
                    <div class="row row-cards">
                        <div class="col-lg-12">
                            <div class="card card-lg">
                                <div class="card-body">
                                    <div class="markdown">
                                        <!-- <h2>Licencia de Uso de la Información Pública - Decreto 4064 - Ley Nro. 5282/2014</h2>
                                        <hr> -->
                                        <h2 :align="'center'">Lic. Yassir Admen</h2>
                                        <p :align="'center'">Director General - Dirección General de TIC</p>
                                        <h2 :align="'center'">C.P. Aristides Silva Figari</h2>
                                        <p :align="'center'">Director de Area - Dirección de Soluciones Tecnológicas</p>
                                        <h2 :align="'center'">Ing. Inf. José Arzamendia</h2>
                                        <p :align="'center'">Director de Area - Dirección de Infraestructura</p>
                                        <h2 :align="'center'">Lic. Ana Maricel Rolón</h2>
                                        <p :align="'center'">Jefa - Departamento de Desarrollo de Sistemas</p>
                                        <h2 :align="'center'">Lic. Marcelo González</h2>
                                        <p :align="'center'">Backend Dev</p>
                                        <h2 :align="'center'">David Sánchez</h2>
                                        <p :align="'center'">Frontend Dev</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Staff',
    data() {
        return {
            content: '',
        };
    },
    components: {
        // TabHeader, TabFooter, PortalDjbr
    }
};


</script>